import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	spotlightHeadline: {
		id: 'experiment-contextual-collab-onboarding-for-new-end-users.emoji-popover-spotlight.headline',
		defaultMessage: 'Share your reaction',
		description: 'Headline for the emoji popover spotlight',
	},
	spotlightBody: {
		id: 'experiment-contextual-collab-onboarding-for-new-end-users.emoji-popover-spotlight.body',
		defaultMessage: 'Leave a quick reaction to let your teammates know what you think!',
		description: 'Body text for the emoji popover spotlight',
	},
	spotlightDone: {
		id: 'experiment-contextual-collab-onboarding-for-new-end-users.emoji-popover-spotlight.done',
		defaultMessage: 'OK',
		description: 'Done button text for the emoji popover spotlight',
	},
});
